import { Outlet } from 'react-router-dom';

const StatusRoot = () => {
  return <Outlet />;
};

export default StatusRoot;
